import { wc } from 'utils/web-component';
import { App } from 'components/App';

customElements.define('ex3d-app', wc(App));
